import { ComponentBase } from '../../../component-base';
import { IMouseDown, IMouseMove, IMouseRelease } from '../Interfaces';
import { Injectable } from '@angular/core';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { common } from '../common';
import { Text } from '../object3D/Text/index';
import { TextArrow } from '../object3D/Text/TextArrow';
import { ArrowHolder } from '../object3D/Text/ArrowHolder';
import { SelectComponent } from './SelectComponent';
import { ConnectionPoint } from '../object3D';
import { config } from './EditDimensionsComponent';

declare let THREE: any;

@Injectable()
export class MoveTextArrow extends ComponentBase implements IMouseDown, IMouseMove, IMouseRelease {
  private selectedObject?: Text;
  private raycaster = new THREE.Raycaster(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -1, 0));
  textArrow: any;
  arrowHolder: ArrowHolder;
  conPoint: ConnectionPoint;
  isEnd: boolean;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        if (obj[0] instanceof Text) {
          this.selectedObject = obj[0];
          this.selectedObject.children
            .filter(ch => ch instanceof TextArrow)
            .forEach(txtArr => {
              const arr = txtArr.children.filter(a => a instanceof ArrowHolder)[0];
              if (arr.visible) {
                txtArr.changePointsVisibility(true);
              }
            });
        } else {
          if (this.selectedObject) {
            this.selectedObject.children
              .filter(ch => ch instanceof TextArrow)
              .forEach(txtArr => {
                txtArr.changePointsVisibility(false);
              });
          }
          this.selectedObject = null;
        }
      } else {
        this.selectedObject = null;
      }
    });
  }

  mouseDown(e: MouseEvent) {
    const selectedObject = this.selectedObject;
    if (selectedObject) {
      const textArrow = this.selectedObject.children.filter(ch => ch instanceof TextArrow)[0];

      const conPoints = textArrow.children.filter(ch => ch instanceof ConnectionPoint);

      const position = this.positionCalculator.calculate(e);
      this.raycaster.ray.origin.copy(position).setY(common.raycastAtY);
      const intersection = this.raycaster.intersectObjects(conPoints);
      if (intersection.length !== 0) {
        this.conPoint = intersection[0].object as ConnectionPoint;
        this.textArrow = this.conPoint.parent;
        this.isEnd = this.conPoint.userData.prevLineId ? true : false;
        this.selectComponent.disable();
        return true;
      }
    }
    return false;
  }

  mouseMove(e: MouseEvent) {
    if (this.conPoint) {
      const positionOffset = this.selectedObject.position.clone().setY(0);
      const position = this.positionCalculator.calculate(e).setY(0).sub(positionOffset);

      if (this.isEnd) {
        this.textArrow.update(this.textArrow.startPoint, position);
      } else {
        this.textArrow.update(position, this.textArrow.endPoint);
      }
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    if (this.conPoint) {
      this.conPoint = null;
      this.textArrow = null;
      this.selectComponent.enable();
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveTextArrow.ts